import React, { useState, useEffect } from 'react';
import '../styles.css';
import { useDispatch, useSelector } from 'react-redux';
import { HELPED_KEY, YOUTUBE_CM } from '../const';
import BackButton from '../../CM/COMPONENTS/BackButton';
import { Background } from '../../CM/COMPONENTS/Background';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';
import ContactButton from '../../HOME/COMPONENTS/ContactButton';
import { Star } from '../COMPONENTS/Cell';
import { FORCE_UPDATE, GOTO_GAME_PAGE } from '../../HOME/REDUX/actions';
import { scrollClass, dbget, dbset } from '../../HOME/utils';
import PlayIcon from '../../HOME/SVG/PlayIcon';
import { YOUTUBE } from '../../HOME/const';

const HelpPage = () => {
  const [play, setPlay] = useState(false);
  const dispatch = useDispatch();
  const { size } = useSelector(state => state.cm);

  useEffect(() => {
    const forceUpdate = () => dispatch({ type: FORCE_UPDATE });
    window.addEventListener('resize', forceUpdate);

    if (size !== undefined) {
      dbget(HELPED_KEY, response => setPlay(!response));
    }

    return () => {
      window.removeEventListener('resize', forceUpdate);
      dbset(HELPED_KEY, true);
      dispatch({ type: HELPED_KEY });
    };
  }, [dispatch, size]);

  const color = 'lightgoldenrodyellow';

  return (
    <div className="page-root cm-page" style={{ backgroundImage: Background }}>
      <div className={`${scrollClass} cm-help`}>
        <div>Compose the background color from the red, yellow and blue components:</div>
        <div className="cm-help-pic1">
          <div style={{ background: '#1A611A' }} />
          <div className="cm-help-operator">=</div>
          <div style={{ background: '#FF8080', display: 'grid' }}>
            <span className="cm-picker-bullet" />
          </div>
          <div className="cm-help-operator">+</div>
          <div style={{ background: '#FFC000', display: 'grid' }}>
            <span className="cm-picker-bullet" />
          </div>
          <div className="cm-help-operator">+</div>
          <div style={{ background: '#2A6099', display: 'grid' }}>
            <span className="cm-picker-bullet" />
          </div>
        </div>
        <div style={{ marginTop: '1em' }}>Clear the grid by matching the background color to the color of starred cells:</div>
        <div className="cm-help-pic2">
          <div className="cm-help-cluster" style={{ background: '#95B0CC' }}>
            <div className="cm-help-cell" style={{ gridArea: '1/1', background: '#FF6400' }}>
              <Star width="12px" />
            </div>
            <div className="cm-help-cell" style={{ gridArea: '2/1', background: '#5A0C40' }}>
              <Star width="12px" />
            </div>
            <div className="cm-help-cell" style={{ gridArea: '2/2', background: '#1A611A' }}>
              <Star width="12px" />
            </div>
          </div>
          <div className="cm-help-arrow">=></div>
          <div className="cm-help-cluster" style={{ background: '#1A611A' }}>
            <div className="cm-help-cell" style={{ gridArea: '1/1', background: '#FF6400' }}>
              <Star width="12px" />
            </div>
            <div className="cm-help-cell" style={{ gridArea: '2/1', background: '#5A0C40' }}>
              <Star width="12px" />
            </div>
            <div className="cm-help-cell" style={{ gridArea: '2/2', background: '#1A611A', border: '1px dotted white' }}>
              <Star width="12px" />
            </div>
          </div>
          <div className="cm-help-arrow">=></div>
          <div className="cm-help-cluster" style={{ background: '#1A611A' }}>
            <div className="cm-help-cell" style={{ gridArea: '1/1', background: '#FF6400' }}>
              <Star width="12px" />
            </div>
            <div className="cm-help-cell" style={{ gridArea: '2/1', background: '#5A0C40' }}>
              <Star width="12px" />
            </div>
          </div>
        </div>
        <div style={{ marginTop: '1em' }}>
          <span style={{ color }}>TIMED MODE</span>: clear the grid as quickly as possible. Your grade is based on your time and the number of
          games played. <span style={{ color }}>Play 10 times or more</span> to get full credit.
        </div>
        <div style={{ marginTop: '1em' }}>
          <span style={{ color }}>TETRIS MODE</span>: clear as many cells as possible before the grid fills up. Get a point for each cleared
          cell. Get 10 extra points each time the grid is completely cleared.
        </div>
        <div style={{ marginTop: '1em' }}>
          <span style={{ color }}>Note</span>: a cell cannot be cleared if it is blocked from all four sides.
        </div>
      </div>
      {play && (
        <span className="navigation-button" style={{ left: 'initial', right: '10px' }} onClick={() => dispatch(GOTO_GAME_PAGE)}>
          <PlayIcon width="36" color="white" />
        </span>
      )}
      <div className="home-center-button-toolbar">
        <ContactButton size={36} service={YOUTUBE} url={YOUTUBE_CM} />
      </div>
      <BackButton />
      <HomeButton />
    </div>
  );
};

export default HelpPage;
